import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface IConfirmMedia {
  kind: 'card' | 'seal' | 'symbol' | 'glyph';
  url?: string | null;
  bg?: string;
  symbol?: string;
  code?: string;
}

export interface IConfirmOptions {
  title: string;
  body?: string;
  /** Ícono del cuadro (UI Icon). */
  icon?: string;
  iconTone?: 'danger' | 'brand';
  hideIcon?: boolean;
  tone?: 'danger' | 'primary';
  layout?: 'left' | 'center';
  media?: IConfirmMedia;
  impact?: string[];
  warning?: string;
  /** Palabra que el usuario debe escribir para habilitar la acción. */
  confirmWord?: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmIcon?: string;
  /** Deshabilita la acción (p. ej. categoría con negocios). */
  blocked?: boolean;
  size?: 'm' | 'l';
  /** Acción asíncrona: el diálogo muestra «cargando» y solo cierra si devuelve true. */
  action?: () => Promise<boolean>;
}

/** Diálogo de confirmación (eliminar negocio/tarjeta/sello/categoría/red, publicar, cerrar sesión). */
@Component({
  selector: 'app-confirm-dialog',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  readonly modal = inject(NgbActiveModal);
  options!: IConfirmOptions;
  readonly typed = signal('');
  readonly busy = signal(false);

  readonly canConfirm = computed(() => {
    if (this.options?.blocked || this.busy()) return false;
    const word = this.options?.confirmWord;
    return !word || this.typed().trim().toUpperCase() === word.toUpperCase();
  });

  async confirm(): Promise<void> {
    if (!this.canConfirm()) return;
    if (!this.options.action) { this.modal.close(true); return; }
    this.busy.set(true);
    const ok = await this.options.action();
    this.busy.set(false);
    if (ok) this.modal.close(true);
  }

  cancel(): void {
    if (!this.busy()) this.modal.dismiss();
  }
}
